module.exports = __webpack_public_path__ + "img/traffic-light.da235a03.svg";